import { render, staticRenderFns } from "./layout-cooperation-left.vue?vue&type=template&id=348848bd&scoped=true"
import script from "./layout-cooperation-left.vue?vue&type=script&lang=js"
export * from "./layout-cooperation-left.vue?vue&type=script&lang=js"
import style0 from "./layout-cooperation-left.vue?vue&type=style&index=0&id=348848bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348848bd",
  null
  
)

export default component.exports